module.exports = __webpack_public_path__ + "img/experienced-hire-1.819f5a65.png";